export default `<svg
  width="429"
  height="101"
  viewBox="0 0 429 101"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g opacity="0.3" filter="url(#filter0_i_909_33931)">
    <g clip-path="url(#clip0_909_33931)">
      <rect
        x="0.505859"
        y="30.9414"
        width="40"
        height="40"
        rx="6.06061"
        fill="#454545"
        fill-opacity="0.42"
      />
      <g filter="url(#filter1_d_909_33931)">
        <rect
          x="2.32397"
          y="32.7595"
          width="36.3636"
          height="36.3636"
          rx="3.96118"
          fill="url(#paint0_linear_909_33931)"
        />
        <rect
          x="2.47549"
          y="32.911"
          width="36.0606"
          height="36.0606"
          rx="3.80966"
          stroke="#757575"
          stroke-width="0.30303"
        />
        <g filter="url(#filter2_i_909_33931)">
          <path
            d="M29.6836 40.9414H20.0521C20.0521 43.3415 21.998 45.2874 24.398 45.2874H26.1719V47.0019C26.1739 49.3966 28.1125 51.3379 30.5052 51.3445H30.5059V41.7797C30.5059 41.7783 30.5059 41.7777 30.5059 41.7763C30.5059 41.3195 30.1391 40.9487 29.6843 40.9421H29.6836V40.9414ZM24.9182 45.7388H15.2866C15.2873 48.1389 17.2325 50.0841 19.6326 50.0841H21.4065V51.7993C21.4085 54.1987 23.353 56.1426 25.7524 56.1446V46.5738C25.7524 46.113 25.379 45.7395 24.9182 45.7395V45.7388ZM20.1488 50.5356H10.5059C10.5072 52.9363 12.4538 54.8816 14.8545 54.8816C14.8585 54.8816 14.8625 54.8816 14.8665 54.8816H16.641V56.5954C16.641 58.9948 18.5856 60.9401 20.985 60.9414V51.3732C20.985 50.9104 20.6102 50.5356 20.1474 50.5356H20.1488Z"
            fill="#D0CFCF"
          />
        </g>
      </g>
    </g>
  </g>
  <g opacity="0.5" filter="url(#filter3_i_909_33931)">
    <g clip-path="url(#clip1_909_33931)">
      <rect
        x="72.5059"
        y="20.9414"
        width="60"
        height="60"
        rx="9.09091"
        fill="#454545"
        fill-opacity="0.42"
      />
      <g filter="url(#filter4_d_909_33931)">
        <rect
          x="75.2332"
          y="23.6687"
          width="54.5455"
          height="54.5455"
          rx="5.94177"
          fill="url(#paint1_linear_909_33931)"
        />
        <rect
          x="75.4604"
          y="23.896"
          width="54.0909"
          height="54.0909"
          rx="5.7145"
          stroke="#757575"
          stroke-width="0.454545"
        />
        <g filter="url(#filter5_i_909_33931)">
          <path
            d="M107.701 47.2596H101.514V35.1914H107.701C111.04 35.1914 113.756 37.8977 113.756 41.2248C113.756 44.552 111.04 47.2596 107.701 47.2596ZM103.498 45.283H107.701C109.947 45.283 111.772 43.4622 111.772 41.2262C111.772 38.9902 109.945 37.1694 107.701 37.1694H103.498V45.283ZM103.498 47.2596H97.3123C93.9734 47.2596 91.2575 44.5533 91.2575 41.2262C91.2575 37.8991 93.9734 35.1914 97.3123 35.1914H103.499V47.2596H103.498ZM97.3123 37.1681C95.067 37.1681 93.2411 38.9888 93.2411 41.2248C93.2411 43.4608 95.067 45.283 97.3123 45.283H101.516V37.1681H97.3123ZM103.498 57.3498H97.3123C93.9734 57.3498 91.2575 54.6435 91.2575 51.3164C91.2575 47.9893 93.9734 45.283 97.3123 45.283H103.499V57.3498H103.498ZM97.3123 47.2596C95.067 47.2596 93.2411 49.0804 93.2411 51.3164C93.2411 53.5524 95.0684 55.3732 97.3123 55.3732H101.516V47.2596H97.3123ZM97.3447 67.4414C93.9882 67.4414 91.2561 64.7351 91.2561 61.408C91.2561 58.0808 93.972 55.3745 97.3109 55.3745H103.498V61.3421C103.498 64.7055 100.738 67.4414 97.3447 67.4414ZM97.3123 57.3498C96.233 57.3513 95.1983 57.7791 94.4351 58.5396C93.6719 59.3001 93.2425 60.3311 93.2411 61.4066C93.2411 63.644 95.0818 65.4634 97.346 65.4634C99.6452 65.4634 101.517 63.6144 101.517 61.3408V57.3498H97.3123ZM107.701 57.3498H107.569C104.23 57.3498 101.514 54.6435 101.514 51.3164C101.514 47.9893 104.23 45.283 107.569 45.283H107.701C111.04 45.283 113.756 47.9893 113.756 51.3164C113.756 54.6435 111.04 57.3498 107.701 57.3498ZM107.57 47.2596C105.325 47.2596 103.499 49.0804 103.499 51.3164C103.499 53.5524 105.327 55.3732 107.57 55.3732H107.703C109.948 55.3732 111.774 53.5524 111.774 51.3164C111.774 49.0804 109.945 47.2596 107.701 47.2596H107.57Z"
            fill="#3E3E3E"
          />
          <path
            d="M107.701 47.2596H101.514V35.1914H107.701C111.04 35.1914 113.756 37.8977 113.756 41.2248C113.756 44.552 111.04 47.2596 107.701 47.2596ZM103.498 45.283H107.701C109.947 45.283 111.772 43.4622 111.772 41.2262C111.772 38.9902 109.945 37.1694 107.701 37.1694H103.498V45.283ZM103.498 47.2596H97.3123C93.9734 47.2596 91.2575 44.5533 91.2575 41.2262C91.2575 37.8991 93.9734 35.1914 97.3123 35.1914H103.499V47.2596H103.498ZM97.3123 37.1681C95.067 37.1681 93.2411 38.9888 93.2411 41.2248C93.2411 43.4608 95.067 45.283 97.3123 45.283H101.516V37.1681H97.3123ZM103.498 57.3498H97.3123C93.9734 57.3498 91.2575 54.6435 91.2575 51.3164C91.2575 47.9893 93.9734 45.283 97.3123 45.283H103.499V57.3498H103.498ZM97.3123 47.2596C95.067 47.2596 93.2411 49.0804 93.2411 51.3164C93.2411 53.5524 95.0684 55.3732 97.3123 55.3732H101.516V47.2596H97.3123ZM97.3447 67.4414C93.9882 67.4414 91.2561 64.7351 91.2561 61.408C91.2561 58.0808 93.972 55.3745 97.3109 55.3745H103.498V61.3421C103.498 64.7055 100.738 67.4414 97.3447 67.4414ZM97.3123 57.3498C96.233 57.3513 95.1983 57.7791 94.4351 58.5396C93.6719 59.3001 93.2425 60.3311 93.2411 61.4066C93.2411 63.644 95.0818 65.4634 97.346 65.4634C99.6452 65.4634 101.517 63.6144 101.517 61.3408V57.3498H97.3123ZM107.701 57.3498H107.569C104.23 57.3498 101.514 54.6435 101.514 51.3164C101.514 47.9893 104.23 45.283 107.569 45.283H107.701C111.04 45.283 113.756 47.9893 113.756 51.3164C113.756 54.6435 111.04 57.3498 107.701 57.3498ZM107.57 47.2596C105.325 47.2596 103.499 49.0804 103.499 51.3164C103.499 53.5524 105.327 55.3732 107.57 55.3732H107.703C109.948 55.3732 111.774 53.5524 111.774 51.3164C111.774 49.0804 109.945 47.2596 107.701 47.2596H107.57Z"
            fill="#D0CFCF"
          />
        </g>
      </g>
    </g>
  </g>
  <g filter="url(#filter6_i_909_33931)">
    <g clip-path="url(#clip2_909_33931)">
      <rect
        x="164.506"
        y="0.941406"
        width="100"
        height="100"
        rx="15.1515"
        fill="#454545"
        fill-opacity="0.42"
      />
      <g filter="url(#filter7_d_909_33931)">
        <rect
          x="169.051"
          y="5.48682"
          width="90.9091"
          height="90.9091"
          rx="9.90295"
          fill="url(#paint2_linear_909_33931)"
        />
        <rect
          x="169.43"
          y="5.8656"
          width="90.1515"
          height="90.1515"
          rx="9.52416"
          stroke="#595959"
          stroke-width="0.757576"
        />
        <g filter="url(#filter8_i_909_33931)">
          <path
            d="M194.424 41.464C194.424 39.6297 195.152 37.8706 196.449 36.5736C197.746 35.2766 199.506 34.548 201.34 34.548H207.917C208.602 34.548 209.023 33.8356 208.761 33.204C208.628 32.8934 208.523 32.5717 208.447 32.2426C207.684 28.8146 210.273 25.3267 214.019 25.3267C217.768 25.3267 220.354 28.8146 219.591 32.2426C219.515 32.5717 219.41 32.8934 219.278 33.204C219.012 33.8356 219.437 34.548 220.121 34.548H224.393C226.227 34.548 227.986 35.2766 229.283 36.5736C230.58 37.8706 231.309 39.6297 231.309 41.464V45.7357C231.309 46.4204 232.019 46.8423 232.653 46.5795C232.964 46.4504 233.282 46.3397 233.614 46.266C237.042 45.5029 240.53 48.0895 240.53 51.8379C240.53 55.5864 237.042 58.173 233.614 57.4099C233.285 57.3341 232.964 57.2291 232.653 57.0964C232.021 56.8313 231.309 57.2554 231.309 57.9401V64.5172C231.309 66.3515 230.58 68.1106 229.283 69.4076C227.986 70.7046 226.227 71.4332 224.393 71.4332H220.029C219.365 71.4332 218.939 70.7624 219.13 70.1284C219.225 69.8057 219.296 69.4737 219.326 69.1279C219.387 68.3938 219.296 67.655 219.057 66.9581C218.818 66.2613 218.437 65.6216 217.938 65.0795C217.439 64.5373 216.834 64.1046 216.159 63.8086C215.484 63.5126 214.756 63.3598 214.019 63.3598C213.282 63.3598 212.554 63.5126 211.879 63.8086C211.205 64.1046 210.599 64.5373 210.1 65.0795C209.601 65.6216 209.22 66.2613 208.982 66.9581C208.743 67.655 208.651 68.3938 208.712 69.1279C208.742 69.4737 208.814 69.8057 208.911 70.1284C209.1 70.7624 208.673 71.4332 208.011 71.4332H201.34C199.506 71.4332 197.746 70.7046 196.449 69.4076C195.152 68.1106 194.424 66.3515 194.424 64.5172V57.8479C194.424 57.184 195.095 56.7575 195.729 56.9488C196.051 57.0434 196.383 57.1148 196.729 57.1448C197.463 57.206 198.202 57.1143 198.899 56.8754C199.596 56.6366 200.235 56.2557 200.778 55.7569C201.32 55.2582 201.752 54.6523 202.048 53.9778C202.344 53.3032 202.497 52.5746 202.497 51.8379C202.497 51.1013 202.344 50.3726 202.048 49.6981C201.752 49.0235 201.32 48.4177 200.778 47.9189C200.235 47.4202 199.596 47.0393 198.899 46.8004C198.202 46.5615 197.463 46.4698 196.729 46.5311C196.383 46.561 196.051 46.6325 195.729 46.7293C195.095 46.9184 194.424 46.4919 194.424 45.8302V41.464Z"
            fill="#D0CFCF"
          />
        </g>
      </g>
    </g>
  </g>
  <g opacity="0.5" filter="url(#filter9_i_909_33931)">
    <g clip-path="url(#clip3_909_33931)">
      <rect
        x="296.506"
        y="20.9414"
        width="60"
        height="60"
        rx="9.09091"
        fill="#454545"
        fill-opacity="0.42"
      />
      <g filter="url(#filter10_d_909_33931)">
        <rect
          x="299.233"
          y="23.6687"
          width="54.5455"
          height="54.5455"
          rx="5.94177"
          fill="url(#paint3_linear_909_33931)"
        />
        <rect
          x="299.46"
          y="23.896"
          width="54.0909"
          height="54.0909"
          rx="5.7145"
          stroke="#757575"
          stroke-width="0.454545"
        />
        <g
          clip-path="url(#clip4_909_33931)"
          filter="url(#filter11_i_909_33931)"
        >
          <path
            d="M326.539 32.9546C316.589 32.9546 308.519 41.023 308.519 50.9746C308.519 58.9364 313.682 65.6909 320.843 68.074C321.743 68.2407 322.034 67.6821 322.034 67.2076V63.8528C317.022 64.943 315.978 61.7265 315.978 61.7265C315.158 59.6437 313.976 59.0896 313.976 59.0896C312.341 57.9708 314.101 57.9948 314.101 57.9948C315.91 58.121 316.863 59.8524 316.863 59.8524C318.469 62.6065 321.078 61.8106 322.106 61.3496C322.267 60.1858 322.734 59.3899 323.251 58.9409C319.249 58.4829 315.041 56.9377 315.041 50.0345C315.041 48.0658 315.745 46.4591 316.897 45.1977C316.711 44.7427 316.094 42.9091 317.073 40.4284C317.073 40.4284 318.586 39.9448 322.03 42.2754C323.467 41.876 325.008 41.6763 326.539 41.6687C328.071 41.6763 329.613 41.876 331.053 42.2754C334.494 39.9448 336.004 40.4284 336.004 40.4284C336.985 42.9106 336.368 44.7442 336.181 45.1977C337.338 46.4591 338.036 48.0673 338.036 50.0345C338.036 56.9557 333.821 58.4799 329.808 58.9259C330.454 59.4845 331.044 60.5807 331.044 62.2626V67.2076C331.044 67.6866 331.333 68.2497 332.247 68.0725C339.403 65.6864 344.559 58.9334 344.559 50.9746C344.559 41.023 336.491 32.9546 326.539 32.9546Z"
            fill="#D0CFCF"
          />
        </g>
      </g>
    </g>
  </g>
  <g opacity="0.3" filter="url(#filter12_i_909_33931)">
    <g clip-path="url(#clip5_909_33931)">
      <rect
        x="388.506"
        y="30.9414"
        width="40"
        height="40"
        rx="6.06061"
        fill="#454545"
        fill-opacity="0.42"
      />
      <g filter="url(#filter13_d_909_33931)">
        <rect
          x="390.324"
          y="32.7595"
          width="36.3636"
          height="36.3636"
          rx="3.96118"
          fill="url(#paint4_linear_909_33931)"
        />
        <rect
          x="390.475"
          y="32.911"
          width="36.0606"
          height="36.0606"
          rx="3.80966"
          stroke="#757575"
          stroke-width="0.30303"
        />
        <g filter="url(#filter14_i_909_33931)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M414.856 44.5774C411.355 41.0764 405.687 41.0628 402.169 44.5366L414.897 57.2642C418.37 53.7463 418.357 48.0785 414.856 44.5774ZM400.373 47.0514L412.382 59.06C413.005 58.7615 413.6 58.3872 414.155 57.937L401.496 45.278C401.046 45.8326 400.672 46.4284 400.373 47.0514ZM408.998 59.9272L399.506 50.4352C399.551 49.6297 399.704 48.8291 399.964 48.0569L411.376 59.4687C410.604 59.7293 409.803 59.8821 408.998 59.9272ZM402.128 57.3054C400.611 55.7882 399.748 53.8641 399.541 51.8845L407.549 59.8922C405.569 59.6848 403.645 58.8225 402.128 57.3054Z"
            fill="#D0CFCF"
          />
        </g>
      </g>
    </g>
  </g>
  <defs>
    <filter
      id="filter0_i_909_33931"
      x="0.505859"
      y="30.7394"
      width="40"
      height="40.202"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.20202" />
      <feGaussianBlur stdDeviation="0.707071" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter1_d_909_33931"
      x="0.808823"
      y="31.7494"
      width="39.3938"
      height="39.3938"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.505051" />
      <feGaussianBlur stdDeviation="0.757576" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_909_33931"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_909_33931"
        result="shape"
      />
    </filter>
    <filter
      id="filter2_i_909_33931"
      x="8.51465"
      y="38.9502"
      width="24.2725"
      height="24.2725"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.245902" dy="0.245902" />
      <feGaussianBlur stdDeviation="0.327869" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter3_i_909_33931"
      x="72.5059"
      y="20.6384"
      width="60"
      height="60.303"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.30303" />
      <feGaussianBlur stdDeviation="1.06061" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter4_d_909_33931"
      x="72.9604"
      y="22.1535"
      width="59.0909"
      height="59.0909"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.757576" />
      <feGaussianBlur stdDeviation="1.13636" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_909_33931"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_909_33931"
        result="shape"
      />
    </filter>
    <filter
      id="filter5_i_909_33931"
      x="84.5193"
      y="32.9546"
      width="36.4089"
      height="36.4089"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.368852" dy="0.368852" />
      <feGaussianBlur stdDeviation="0.491803" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter6_i_909_33931"
      x="164.506"
      y="0.436356"
      width="100"
      height="100.505"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.50505" />
      <feGaussianBlur stdDeviation="1.76768" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter7_d_909_33931"
      x="165.263"
      y="2.96156"
      width="98.4849"
      height="98.4849"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="1.26263" />
      <feGaussianBlur stdDeviation="1.89394" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_909_33931"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_909_33931"
        result="shape"
      />
    </filter>
    <filter
      id="filter8_i_909_33931"
      x="194.424"
      y="25.3267"
      width="46.7212"
      height="46.7212"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.614754" dy="0.614754" />
      <feGaussianBlur stdDeviation="0.819672" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter9_i_909_33931"
      x="296.506"
      y="20.6384"
      width="60"
      height="60.303"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.30303" />
      <feGaussianBlur stdDeviation="1.06061" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter10_d_909_33931"
      x="296.96"
      y="22.1535"
      width="59.0909"
      height="59.0909"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.757576" />
      <feGaussianBlur stdDeviation="1.13636" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_909_33931"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_909_33931"
        result="shape"
      />
    </filter>
    <filter
      id="filter11_i_909_33931"
      x="308.519"
      y="32.9546"
      width="36.4089"
      height="36.4089"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.368852" dy="0.368852" />
      <feGaussianBlur stdDeviation="0.491803" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter12_i_909_33931"
      x="388.506"
      y="30.7394"
      width="40"
      height="40.202"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="-0.20202" />
      <feGaussianBlur stdDeviation="0.707071" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <filter
      id="filter13_d_909_33931"
      x="388.809"
      y="31.7494"
      width="39.3938"
      height="39.3938"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.505051" />
      <feGaussianBlur stdDeviation="0.757576" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_909_33931"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_909_33931"
        result="shape"
      />
    </filter>
    <filter
      id="filter14_i_909_33931"
      x="396.515"
      y="38.9502"
      width="24.2725"
      height="24.2725"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="0.245902" dy="0.245902" />
      <feGaussianBlur stdDeviation="0.327869" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_909_33931"
      />
    </filter>
    <linearGradient
      id="paint0_linear_909_33931"
      x1="7.37448"
      y1="33.5171"
      x2="28.6876"
      y2="69.5777"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#383838" />
      <stop offset="0.260417" stop-color="#2A2A2A" />
      <stop offset="0.619792" stop-color="#393939" />
      <stop offset="1" stop-color="#414141" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_909_33931"
      x1="82.8089"
      y1="24.8051"
      x2="114.779"
      y2="78.896"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#383838" />
      <stop offset="0.260417" stop-color="#2A2A2A" />
      <stop offset="0.619792" stop-color="#393939" />
      <stop offset="1" stop-color="#414141" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_909_33931"
      x1="181.678"
      y1="7.38076"
      x2="234.96"
      y2="97.5323"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#383838" />
      <stop offset="0.260417" stop-color="#2A2A2A" />
      <stop offset="0.619792" stop-color="#393939" />
      <stop offset="1" stop-color="#414141" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_909_33931"
      x1="306.809"
      y1="24.8051"
      x2="338.779"
      y2="78.896"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#383838" />
      <stop offset="0.260417" stop-color="#2A2A2A" />
      <stop offset="0.619792" stop-color="#393939" />
      <stop offset="1" stop-color="#414141" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_909_33931"
      x1="395.374"
      y1="33.5171"
      x2="416.688"
      y2="69.5777"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#383838" />
      <stop offset="0.260417" stop-color="#2A2A2A" />
      <stop offset="0.619792" stop-color="#393939" />
      <stop offset="1" stop-color="#414141" />
    </linearGradient>
    <clipPath id="clip0_909_33931">
      <rect
        x="0.505859"
        y="30.9414"
        width="40"
        height="40"
        rx="6.06061"
        fill="white"
      />
    </clipPath>
    <clipPath id="clip1_909_33931">
      <rect
        x="72.5059"
        y="20.9414"
        width="60"
        height="60"
        rx="9.09091"
        fill="white"
      />
    </clipPath>
    <clipPath id="clip2_909_33931">
      <rect
        x="164.506"
        y="0.941406"
        width="100"
        height="100"
        rx="15.1515"
        fill="white"
      />
    </clipPath>
    <clipPath id="clip3_909_33931">
      <rect
        x="296.506"
        y="20.9414"
        width="60"
        height="60"
        rx="9.09091"
        fill="white"
      />
    </clipPath>
    <clipPath id="clip4_909_33931">
      <rect
        width="36.0399"
        height="36.0399"
        fill="white"
        transform="translate(308.519 32.9546)"
      />
    </clipPath>
    <clipPath id="clip5_909_33931">
      <rect
        x="388.506"
        y="30.9414"
        width="40"
        height="40"
        rx="6.06061"
        fill="white"
      />
    </clipPath>
  </defs>
</svg>`;
